import {
  all, call, put, select, takeLatest,
} from 'redux-saga/effects';
import { getResults } from 'circe/queryListing/selectors';
import { changeData } from 'circe/queryListing/actions';
import startManifestingSaga from './StartManifest/saga';
import { started } from './StartManifest/actions';
import { REDUCER_NAME } from '../../operations/drivers/docs/constants';

function* doStartManifest({ payload }) {
  const state = yield select();
  const details = yield call(getResults, state, 'ORDER_DETAILS');
  const { data } = payload;
  if (data !== null) {
    yield put(
      changeData('ORDER_DETAILS', {
        ...details,
        maifests: data.items ? data.items.map((item) => item.manifest) : [],
        order: {
          ...details.order,
          status: 'MANIFESTING',
        },
      }),
    );

    // CREATE_MASTER_WAYBILL
  }
}

export default function* (context) {
  yield all([takeLatest(started().type, doStartManifest), startManifestingSaga(context)]);
}
